export default __webpack_public_path__ + "static/media/miut_panorama_preview.df0204a3.png";